import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-trip-comments-screen',
    templateUrl: './trip-comments-screen.component.html',
    styleUrls: ['./trip-comments-screen.component.scss'],
})
export class TripCommentsScreenComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
